import React, { createContext, ReactNode, useContext, useState } from 'react';
import {
  PaymentAgent,
  PaymentAgentParams,
  PaymentProvider as BasePaymentProvider,
} from '../PaymentProviders/PaymentProvider';

interface PaymentContextType {
  registerPaymentProvider: (provider: BasePaymentProvider) => void;
  paymentProvider: BasePaymentProvider | undefined;
}

const PaymentContext = createContext<PaymentContextType | undefined>(undefined);

interface PaymentContextProviderProps {
  children: ReactNode;
}
export const PaymentProvider: React.FC<PaymentContextProviderProps> = ({
  children,
}) => {
  let [paymentProvider, setPaymentProvider] = useState<BasePaymentProvider>();

  const registerPaymentProvider = (provider: BasePaymentProvider) => {
    if (paymentProvider?.getId() === provider.getId()) {
      // (don't spam, since we're registering them outside effect)
      // console.warn('Payment provider already registered. Replacing...');
      return;
    }

    setPaymentProvider(provider);
    // This is to make sure that provider becomes available even before state is updated across the app
    paymentProvider = provider;
  };

  return (
    <PaymentContext.Provider
      value={{
        registerPaymentProvider,
        paymentProvider,
      }}
    >
      {children}
    </PaymentContext.Provider>
  );
};

export const usePayments = (): PaymentContextType => {
  const context = useContext(PaymentContext);
  if (context === undefined) {
    throw new Error('usePayments must be used within an PaymentProvider');
  }
  return context;
};
